import React, { Component } from 'react';
import { Table, Row, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data8_1_default, data8_1_2, data8_1_3, data8_2_1 } from './data';
import { compute8_1_2, compute8_1_3 } from "./compute";
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import Compared from "../../Compared";
  import Table2 from "./8-1-2";
// import Table3 from "./8-1-3";
import Table4 from "./8-2";

const { MonthPicker } = DatePicker;
const { TextArea } = Input;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}
const numConvert = (num = 0) => {
    num = Number(num || "0")
    return num
};
const getJson = (arr, obj, value = 0) => {
    return arr.reduce((a, b) => a && a[b] ? a[b] : value, obj)
}
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            note: { note: "" },
            note8_2: { comments: "" },
            loadingSave: false,
            print: false,
            data8_1_2: [],
            data8_1_3: [],
            data8_2_1: [],
        }
    }


    componentDidMount() {
        this.getTable8_1(this.state.date);
    }

    computeNum = (data) => {
        data.forEach((item, i) => {
            data[i].cma_thisyear_average = (numConvert(data[i].cma_thisyear_consumption) == 0 ? 0 : numConvert(data[i].cma_thisyear_cost) / numConvert(data[i].cma_thisyear_consumption)).toFixed(2);
            data[i].cma_lastyear_average = (numConvert(data[i].cma_lastyear_consumption) == 0 ? 0 : numConvert(data[i].cma_lastyear_cost) / numConvert(data[i].cma_lastyear_consumption)).toFixed(2);
            data[i].cma_lastyear_lastmonth_average = (numConvert(data[i].cma_lastyear_lastmonth_consumption) == 0 ? 0 : numConvert(data[i].cma_lastyear_lastmonth_cost) / numConvert(data[i].cma_lastyear_lastmonth_consumption)).toFixed(2);
            data[i].cmv_comparison_consumption = (numConvert(data[i].cma_thisyear_consumption) - numConvert(data[i].cma_lastyear_consumption)).toFixed(2);
            data[i].cmv_comparison_consumption_percent = (numConvert(data[i].cma_lastyear_consumption) == 0 ? 0 : numConvert(data[i].cmv_comparison_consumption) / numConvert(data[i].cma_lastyear_consumption)).toFixed(3);
            data[i].cmv_comparison_average = (numConvert(data[i].cma_thisyear_average) - numConvert(data[i].cma_lastyear_average)).toFixed(2);
            data[i].cmv_comparison_average_percent = (numConvert(data[i].cma_lastyear_average) == 0 ? 0 : numConvert(data[i].cmv_comparison_average) / numConvert(data[i].cma_lastyear_average)).toFixed(3);
            data[i].cmv_comparison_cost = (numConvert(data[i].cma_thisyear_cost) - numConvert(data[i].cma_lastyear_cost)).toFixed(2);
            data[i].cmv_comparison_cost_percent = (numConvert(data[i].cma_lastyear_cost) == 0 ? 0 : numConvert(data[i].cmv_comparison_cost) / numConvert(data[i].cma_lastyear_cost)).toFixed(3);

            data[i].ytda_thisyear_average = (numConvert(data[i].ytda_thisyear_consumption) == 0 ? 0 : numConvert(data[i].ytda_thisyear_cost) / numConvert(data[i].ytda_thisyear_consumption)).toFixed(2);
            data[i].ytda_lastyear_average = (numConvert(data[i].ytda_lastyear_consumption) == 0 ? 0 : numConvert(data[i].ytda_lastyear_cost) / numConvert(data[i].ytda_lastyear_consumption)).toFixed(2);
            data[i].ytdv_comparison_consumption = (numConvert(data[i].ytda_thisyear_consumption) - numConvert(data[i].ytda_lastyear_consumption)).toFixed(2);
            data[i].ytdv_comparison_consumption_percent = (numConvert(data[i].ytda_lastyear_consumption) == 0 ? 0 : numConvert(data[i].ytdv_comparison_consumption) / numConvert(data[i].ytda_lastyear_consumption)).toFixed(3);
            data[i].ytdv_comparison_average = (numConvert(data[i].ytda_thisyear_average) - numConvert(data[i].ytda_lastyear_average)).toFixed(2);
            data[i].ytdv_comparison_average_percent = (numConvert(data[i].ytda_lastyear_average) == 0 ? 0 : numConvert(data[i].ytdv_comparison_average) / numConvert(data[i].ytda_lastyear_average)).toFixed(3);
            data[i].ytdv_comparison_cost = (numConvert(data[i].ytda_thisyear_cost) - numConvert(data[i].ytda_lastyear_cost)).toFixed(2);
            data[i].ytdv_comparison_cost_percent = (numConvert(data[i].ytda_lastyear_cost) == 0 ? 0 : numConvert(data[i].ytdv_comparison_cost) / numConvert(data[i].ytda_lastyear_cost)).toFixed(3);
            //  新增 Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月
            data[i].ytdv_lastmonth_comparison_consumption = (numConvert(data[i].cma_thisyear_consumption) - numConvert(data[i].cma_lastyear_lastmonth_consumption)).toFixed(2);
            data[i].ytdv_lastmonth_comparison_consumption_percent = (numConvert(data[i].cma_lastyear_lastmonth_consumption) == 0 ? 0 : numConvert(data[i].ytdv_lastmonth_comparison_consumption) / numConvert(data[i].cma_lastyear_lastmonth_consumption)).toFixed(3);
            data[i].ytdv_lastmonth_comparison_average = (numConvert(data[i].cma_thisyear_average) - numConvert(data[i].cma_lastyear_lastmonth_average)).toFixed(2);
            data[i].ytdv_lastmonth_comparison_average_percent = (numConvert(data[i].cma_lastyear_lastmonth_average) == 0 ? 0 : numConvert(data[i].ytdv_lastmonth_comparison_average) / numConvert(data[i].cma_lastyear_lastmonth_average)).toFixed(3);
            data[i].ytdv_lastmonth_comparison_cost = (numConvert(data[i].cma_thisyear_cost) - numConvert(data[i].cma_lastyear_lastmonth_cost)).toFixed(2);
            data[i].ytdv_lastmonth_comparison_cost_percent = (numConvert(data[i].cma_lastyear_lastmonth_cost) == 0 ? 0 : numConvert(data[i].ytdv_lastmonth_comparison_cost) / numConvert(data[i].cma_lastyear_lastmonth_cost)).toFixed(3);
        })


        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;

        this.computeNum(data);
    }
    // 获取表格8-1的内容
    getTable8_1 = (date) => {
        const dataBegin = JSON.stringify(data8_1_default);
        let data = JSON.parse(dataBegin);
        const dataBegin2 = JSON.stringify(data8_1_2);
        let data2 = JSON.parse(dataBegin2);
        const dataBegin3 = JSON.stringify(data8_1_3);
        let data3 = JSON.parse(dataBegin3);
        const dataBegin4 = JSON.stringify(data8_2_1);
        let data4 = JSON.parse(dataBegin4);
        this.getNote(date);
        this.getNote8_2(date);
        fetch(`/_8_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data8_1 && x.data.data8_1.length > 0) {
                data = x.data.data8_1;
            }
            if (x.data.data8_1_2 && x.data.data8_1_2.length > 0) {
                data2 = x.data.data8_1_2;
            }
            if (x.data.data8_1_3 && x.data.data8_1_3.length > 0) {
                data3 = x.data.data8_1_3;
            }
            if (x.data.data8_2_1 && x.data.data8_2_1.length > 0) {
                data4 = x.data.data8_2_1;
            }

            // 从5.1.1获取人数总计
            data3[3].cma_thisyear_consumption = getJson([13, 'covers'], x.data.data5_1 || [], 0);
            data3[3].cma_lastyear_lastmonth_consumption = getJson([13, 'covers'], x.data.dataLast5_1 || [], 0);
            data3[3].cma_lastyear_consumption = getJson([13, 'covers'], x.data.dataYear5_1 || [], 0);

            // 从1.1获取出租客房间夜数
            data2[2].cma_thisyear_consumption = getJson([1, 'actual'], x.data.data1_1 || [], 0);
            data2[2].cma_lastyear_lastmonth_consumption = getJson([1, 'actual'], x.data.dataLast1_1 || [], 0);
            data2[2].cma_lastyear_consumption = getJson([1, 'actual'], x.data.dataYear1_1 || [], 0);
            data2[2].ytda_thisyear_consumption = getJson([1, 'year_actual'], x.data.data1_1 || [], 0);
            data2[2].ytda_lastyear_consumption = getJson([1, 'year_actual'], x.data.dataYear1_1 || [], 0);

            this.computeNum(data);
            this.computeNum8_2(data4);
            this.setState({ loading: false, data8_1_2: compute8_1_2(data2), data8_1_3: compute8_1_3(data3) });

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    computeNum8_2 = (data) => {
        data.forEach((item, i) => {
            data[i].lastYear_fee = (numConvert(item.year_now_actual) - numConvert(item.lastYear_now_actual)).toFixed(2);
            data[i].lastYear_percent = (numConvert(item.lastYear_now_actual) == 0 ? 0 : numConvert(item.lastYear_fee) / numConvert(item.lastYear_now_actual)).toFixed(4);
            data[i].year_fee = (numConvert(item.year_now_actual) - numConvert(item.year_last_actual)).toFixed(2);
            data[i].year_percent = (numConvert(item.year_last_actual) == 0 ? 0 : numConvert(item.year_fee) / numConvert(item.year_last_actual)).toFixed(4);
            data[i].last_fee = (numConvert(item.year_actual) - numConvert(item.lastYear_actual)).toFixed(2);
            data[i].last_percent = (numConvert(item.lastYear_actual) == 0 ? 0 : numConvert(item.last_fee) / numConvert(item.lastYear_actual)).toFixed(4);
        })
        this.setState({ data8_2_1: data });
    }

    // 获取表格8-1-1的内容
    getNote = (date) => {
        fetch(`/_8_1_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                this.setState({
                    note: { ...x.data[0] }
                });
            } else {
                this.setState({
                    note: { note: "" }
                });
            }
        }).catch(err => {
            console.error(err);
        })
    }

    // 获取表格8-2的内容
    getNote8_2 = (date) => {
        fetch(`/_8_2_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                this.setState({
                    note8_2: { ...x.data[0] }
                });
            } else {
                this.setState({
                    note8_2: { comments: "" }
                });
            }
        }).catch(err => {
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let data8_1_2 = this.state.data8_1_2.map(x => ({ ...x, year, month }));
        let data8_1_3 = this.state.data8_1_3.map(x => ({ ...x, year, month }));
        let data8_2_1 = this.state.data8_2_1.map(x => ({ ...x, year, month }));

        if (!data[0].squmareMeter || data[0].squmareMeter == 0) {
            message.error('酒店平方米不能为空！');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000);
            return
        }

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify({ data, data8_1_2, data8_1_3, data8_2_1 }));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        if (this.state.note) {
            this.onSaveNote([{ ...this.state.note, month, year, }])
        }
        if (this.state.note8_2) {
            this.onSaveNote8_2([{ ...this.state.note8_2, month, year, }])
        }

        fetch('/add_8_1', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id || !data8_1_2[0].id || !data8_1_3[0].id) {
                    this.getTable8_1(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            message.error('保存失败' + JSON.stringify(err));
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
        })
    }

    onChangeChild = (name, data) => {

    }

    onSaveNote = (data) => {
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_8_1_1', headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                // message.success(x.msg);
                return
            }
            message.error('备注保存失败：' + x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    onSaveNote8_2 = (data) => {
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_8_2', headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                // message.success(x.msg);
                return
            }
            message.error('备注保存失败：' + x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table8', 1.5, '8.00', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const columns = [{
            title: 'Utility Item 能源项目',
            dataIndex: 'utility_item',
            key: 'utility_item',
            align: "center",
            fixed: "left",
            width: 300,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: 'Current Month 本年当月',
            align: "center",
            children: [{
                align: "center",
                title: 'Current Month Actual - This Year 本年当月实际数',
                width: 450,
                children: [{
                    title: <div> Consumption <br /> 消耗量 </div>,
                    dataIndex: 'cma_thisyear_consumption',
                    key: 'cma_thisyear_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Actual - This Year 本年当月实际数', 'Consumption 消耗量'];
                        if (index >= 0 && index <= 3) {
                            return (
                                <Compared data={{ index, key: 'cma_thisyear_consumption', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('cma_thisyear_consumption', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'cma_thisyear_consumption', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div> Average Unit Price <br /> 平均单价 </div>,
                    dataIndex: 'cma_thisyear_average',
                    key: 'cma_thisyear_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Actual - This Year 本年当月实际数', 'Average Unit Price 平均单价'];
                        return (
                            <Compared data={{ index, key: 'cma_thisyear_average', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div> Cost  <br /> 成本费用 </div>,
                    dataIndex: 'cma_thisyear_cost',
                    key: 'cma_thisyear_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Actual - This Year 本年当月实际数', 'Cost 成本费用'];
                        if (index == 4) {
                            return (
                                <Compared data={{ index, key: 'cma_thisyear_cost', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'cma_thisyear_cost', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('cma_thisyear_cost', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'Last Month Actual - Current Year 本年上月实际数',
                width: 450,
                children: [{
                    title: <div> Consumption <br /> 消耗量 </div>,
                    dataIndex: 'cma_lastyear_lastmonth_consumption',
                    key: 'cma_lastyear_lastmonth_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Last Month Actual - Current Year 本年上月实际数', 'Consumption 消耗量'];
                        if (index >= 0 && index <= 3) {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_lastmonth_consumption', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('cma_lastyear_lastmonth_consumption', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_lastmonth_consumption', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div> Average Unit Price <br /> 平均单价 </div>,
                    dataIndex: 'cma_lastyear_lastmonth_average',
                    key: 'cma_lastyear_lastmonth_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Last Month Actual - Current Year 本年上月实际数', 'Average Unit Price 平均单价'];
                        return (
                            <Compared data={{ index, key: 'cma_lastyear_lastmonth_average', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div> Cost  <br /> 成本费用 </div>,
                    dataIndex: 'cma_lastyear_lastmonth_cost',
                    key: 'cma_lastyear_lastmonth_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Last Month Actual - Current Year 本年上月实际数', 'Cost 成本费用'];
                        if (index == 4) {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_lastmonth_cost', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_lastmonth_cost', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('cma_lastyear_lastmonth_cost', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'Current Month Actual - Last Year 去年当月实际数',
                width: 450,
                children: [{
                    title: <div> Consumption <br /> 消耗量 </div>,
                    dataIndex: 'cma_lastyear_consumption',
                    key: 'cma_lastyear_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Actual - Last Year 去年当月实际数', 'Consumption 消耗量'];
                        if (index >= 0 && index <= 3) {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_consumption', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('cma_lastyear_consumption', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_consumption', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div> Average Unit Price <br /> 平均单价 </div>,
                    dataIndex: 'cma_lastyear_average',
                    key: 'cma_lastyear_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Actual - Last Year 去年当月实际数', 'Average Unit Price 平均单价'];
                        return (
                            <Compared data={{ index, key: 'cma_lastyear_average', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div> Cost  <br /> 成本费用 </div>,
                    dataIndex: 'cma_lastyear_cost',
                    key: 'cma_lastyear_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Actual - Last Year 去年当月实际数', 'Cost 成本费用'];
                        if (index == 4) {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_cost', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'cma_lastyear_cost', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('cma_lastyear_cost', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年',
                width: 900,
                children: [{
                    title: <div>Consumption  <br />消耗量</div>,
                    dataIndex: 'cmv_comparison_consumption',
                    key: 'cmv_comparison_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'Consumption 消耗量'];
                        return (
                            <Compared data={{ index, key: 'cmv_comparison_consumption', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding  ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'cmv_comparison_consumption_percent',
                    key: 'cmv_comparison_consumption_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'cmv_comparison_consumption_percent', title, sqlName: "_8_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Average Unit Price<br />平均单价</div>,
                    dataIndex: 'cmv_comparison_average',
                    key: 'cmv_comparison_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'Average Unit Price 平均单价'];
                        return (
                            <Compared data={{ index, key: 'cmv_comparison_average', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'cmv_comparison_average_percent',
                    align: "center",
                    key: 'cmv_comparison_average_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'cmv_comparison_average_percent', title, sqlName: "_8_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Cost <br />成本费用</div>,
                    dataIndex: 'cmv_comparison_cost',
                    key: 'cmv_comparison_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'Cost 成本费用'];
                        return (
                            <Compared data={{ index, key: 'cmv_comparison_cost', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'cmv_comparison_cost_percent',
                    key: 'cmv_comparison_cost_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['Current Month 本年当月', 'Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'cmv_comparison_cost_percent', title, sqlName: "_8_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding  ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }]
            },],
        }, {
            title: 'YTD 年累计',
            align: "center",
            width: 1650,
            children: [{
                align: "center",
                title: 'YTD Actual - This Year 年累计实际 - 今年',
                width: 450,
                children: [{
                    title: <div>Consumption  <br />消耗量</div>,
                    dataIndex: 'ytda_thisyear_consumption',
                    key: 'ytda_thisyear_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - This Year 年累计实际 - 今年', 'Consumption 消耗量'];
                        if (index >= 0 && index <= 3) {
                            return (
                                <Compared data={{ index, key: 'ytda_thisyear_consumption', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('ytda_thisyear_consumption', value, index)
                                            }}
                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'ytda_thisyear_consumption', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div>Average Unit Price<br />平均单价</div>,
                    dataIndex: 'ytda_thisyear_average',
                    key: 'ytda_thisyear_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - This Year 年累计实际 - 今年', 'Average Unit Price 平均单价'];
                        return (
                            <Compared data={{ index, key: 'ytda_thisyear_average', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Cost <br />成本费用</div>,
                    dataIndex: 'ytda_thisyear_cost',
                    key: 'ytda_thisyear_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - This Year 年累计实际 - 今年', 'Cost 成本费用'];
                        if (index == 4) {
                            return (
                                <Compared data={{ index, key: 'ytda_thisyear_cost', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'ytda_thisyear_cost', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('ytda_thisyear_cost', value, index)
                                            }}
                                            onCha
                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'YTD Actual - Last Year 年累计实际 - 去年',
                width: 450,
                children: [{
                    title: <div>Consumption  <br />消耗量</div>,
                    dataIndex: 'ytda_lastyear_consumption',
                    key: 'ytda_lastyear_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - Last Year 年累计实际 - 去年', 'Consumption 消耗量'];
                        if (index >= 0 && index <= 3) {
                            return (
                                <Compared data={{ index, key: 'ytda_lastyear_consumption', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('ytda_lastyear_consumption', value, index)
                                            }}
                                            onCha
                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'ytda_lastyear_consumption', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`}>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div>Average Unit Price<br />平均单价</div>,
                    dataIndex: 'ytda_lastyear_average',
                    key: 'ytda_lastyear_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - Last Year 年累计实际 - 去年', 'Average Unit Price 平均单价'];
                        return (
                            <Compared data={{ index, key: 'ytda_lastyear_average', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Cost <br />成本费用</div>,
                    dataIndex: 'ytda_lastyear_cost',
                    key: 'ytda_lastyear_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - Last Year 年累计实际 - 去年', 'Cost 成本费用'];
                        if (index == 4) {
                            return (
                                <Compared data={{ index, key: 'ytda_lastyear_cost', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'ytda_lastyear_cost', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={Number(text || "0") || ""}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('ytda_lastyear_cost', value, index)
                                            }}
                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月',
                width: 750,
                children: [{
                    title: <div>Consumption <br />消耗量</div>,
                    dataIndex: 'ytdv_lastmonth_comparison_consumption',
                    key: 'ytdv_lastmonth_comparison_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', 'Consumption 消耗量'];
                        return (
                            <Compared data={{ index, key: 'ytdv_lastmonth_comparison_consumption', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding  ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytdv_lastmonth_comparison_consumption_percent',
                    key: 'ytdv_lastmonth_comparison_consumption_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'ytdv_lastmonth_comparison_consumption_percent', title, sqlName: "_8_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Average Unit Price<br />平均单价</div>,
                    dataIndex: 'ytdv_lastmonth_comparison_average',
                    key: 'ytdv_lastmonth_comparison_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', 'Average Unit Price 平均单价'];
                        return (
                            <Compared data={{ index, key: 'ytdv_lastmonth_comparison_average', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytdv_lastmonth_comparison_average_percent',
                    align: "center",
                    key: 'ytdv_lastmonth_comparison_average_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'ytdv_lastmonth_comparison_average_percent', title, sqlName: "_8_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Cost <br />成本费用</div>,
                    dataIndex: 'ytdv_lastmonth_comparison_cost',
                    key: 'ytdv_lastmonth_comparison_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', 'Cost 成本费用'];
                        return (
                            <Compared data={{ index, key: 'ytdv_lastmonth_comparison_cost', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytdv_lastmonth_comparison_cost_percent',
                    align: "center",
                    key: 'ytdv_lastmonth_comparison_cost_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'ytdv_lastmonth_comparison_cost_percent', title, sqlName: "_8_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }]
            }, {
                align: "center",
                title: 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',
                width: 750,
                children: [{
                    title: <div>Consumption <br />消耗量</div>,
                    dataIndex: 'ytdv_comparison_consumption',
                    key: 'ytdv_comparison_consumption',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Consumption 消耗量'];
                        return (
                            <Compared data={{ index, key: 'ytdv_comparison_consumption', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding  ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytdv_comparison_consumption_percent',
                    key: 'ytdv_comparison_consumption_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'ytdv_comparison_consumption_percent', title, sqlName: "_8_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Average Unit Price<br />平均单价</div>,
                    dataIndex: 'ytdv_comparison_average',
                    key: 'ytdv_comparison_average',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Average Unit Price 平均单价'];
                        return (
                            <Compared data={{ index, key: 'ytdv_comparison_average', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytdv_comparison_average_percent',
                    align: "center",
                    key: 'ytdv_comparison_average_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'ytdv_comparison_average_percent', title, sqlName: "_8_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Cost <br />成本费用</div>,
                    dataIndex: 'ytdv_comparison_cost',
                    key: 'ytdv_comparison_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Cost 成本费用'];
                        return (
                            <Compared data={{ index, key: 'ytdv_comparison_cost', title, sqlName: "_8_1", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ytdv_comparison_cost_percent',
                    align: "center",
                    key: 'ytdv_comparison_cost_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', '% 百分比'];
                        return (
                            <Compared data={{ index, key: 'ytdv_comparison_cost_percent', title, sqlName: "_8_1", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${index == 4 ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }]
            },],
        }];
        const squmareMeterStyle = {
            float: "right",
            fontSize: 16,
        }
        const squmareInputStyle = {
            marginLeft: 10,
            width: 120
        };

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table8" style={{ width: this.state.print ? 5300 : 'auto' }}>
                        <Row style={{ marginBottom: 20, fontSize: 24 }}>8.0 Utility Cost Trend Analysis 能源成本趋势分析</Row>
                        <Row>8.1.1 Total Hotel Engergy consumption 酒店总能耗统计</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        note: { note: "" },
                                        note8_2: { comments: "" },
                                        loading: true,
                                        note: { note: "" },
                                        data8_1_2: [],
                                        data8_1_3: [],
                                        data8_2_1: [],
                                    });
                                    this.getTable8_1(str)
                                }}
                            />
                            <Row style={squmareMeterStyle}>
                                酒店平方米 :
                                {!this.state.loading ?
                                    <Compared data={{ index: 0, key: 'squmareMeter', title: [], sqlName: "_8_1", name: "酒店平方米", type: 'number' }}>
                                        <Input
                                            defaultValue={data[0] ? Number(data[0].squmareMeter) : ""}
                                            style={squmareInputStyle}
                                            onBlur={(e) => {
                                                let value = e.target.value || "";
                                                this.onChange('squmareMeter', value, 0);
                                            }}
                                        />
                                    </Compared>
                                    : null} m²
                            </Row>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 5250 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 5250 }}
                            rowKey={(record, index) => index}
                        />
                        {/* <Table2 onChange={(name, data) => { this.setState({ [name]: compute8_1_2(data) }); }} date={this.state.date} data={this.state.data8_1_2} print={this.state.print} />
                        <Table3 onChange={(name, data) => { this.setState({ [name]: compute8_1_3(data) }); }} date={this.state.date} data={this.state.data8_1_3} print={this.state.print} /> */}
                        <Row style={{ margin: "20px 0", }}>
                            <Row style={{ margin: "10px 0" }}>8.1.4  Please critique if variance above +/- 5% 若差异数超过上下百分之五则需做出书面解释</Row>
                            {!this.state.loading || this.state.print ? < TextArea
                                autosize={{ minRows: 4 }}
                                placeholder="请输入备注！"
                                defaultValue={this.state.note.note}
                                onBlur={(e) => {
                                    this.setState({
                                        note: { ...this.state.note, note: e.target.value }
                                    });
                                }}
                            /> : null}
                        </Row>
                        <Row style={{ margin: "20px 0", }}>
                            <Row style={{ margin: "10px 0" }}>8.1.5 Utility Conservation Measures 能源控制措施</Row>
                            {!this.state.loading || this.state.print ? < TextArea
                                autosize={{ minRows: 4 }}
                                placeholder="请输入备注！"
                                defaultValue={this.state.note8_2.comments}
                                onBlur={(e) => {
                                    this.setState({
                                        note8_2: { ...this.state.note8_2, comments: e.target.value }
                                    });
                                }}
                            /> : null}
                        </Row>
                        <Table4 onChange={this.computeNum8_2} date={this.state.date} data={this.state.data8_2_1} /> 
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_8_1">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/8.0/8-1/index.js